import { render, staticRenderFns } from "./AncillarySSRs.vue?vue&type=template&id=867c61f2&scoped=true"
import script from "./AncillarySSRs.vue?vue&type=script&lang=js"
export * from "./AncillarySSRs.vue?vue&type=script&lang=js"
import style0 from "./AncillarySSRs.vue?vue&type=style&index=0&id=867c61f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "867c61f2",
  null
  
)

export default component.exports